export default __webpack_public_path__ + "static/skills-tag-parts-light-a9e1d0dc2b1b7449b637216fdded87ce.png";